import { render, staticRenderFns } from "./ArticlesHome.vue?vue&type=template&id=082982e4"
import script from "./ArticlesHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlesHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports